import { post } from "./divertidogsApiUtils";
import { MetodoPago } from "./ventasServicios";

export interface DetalleNuevaCompra {
  idProducto: string;
  cantidad: number;
  valorFinal: number;
}

export interface NuevaCompra {
  idMascota: string;
  detalles: DetalleNuevaCompra[];
  datosPago?: { metodo: MetodoPago; monto: number };
}

export const comprar = async (nuevaCompra: NuevaCompra): Promise<undefined> => {
  return post<NuevaCompra, undefined>("compras", nuevaCompra);
};
